export default __webpack_public_path__ + "static/media/favicon.676ac15c.ico";